import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CreateDataSetConfigurationRequest, ExportDataSetConfigurationResponse, GetDataSetConfigurationResponse, GetDataSetConfigurationsRequest, GetDataSetConfigurationsResponse, ValidateImportDataSetConfigurationCommandResponse } from '../../models/data-set-configuration-models';
import { environment } from '../../../../environments/environment';
import { ImportRequest } from '../../models/models';

@Injectable({
  providedIn: 'root'
})
export class DataSetConfigurationService {
  private api = `${environment.baseV5ApiUri}/DataSetConfiguration`;
  constructor(private http: HttpClient) { }

  getFiltered(request: GetDataSetConfigurationsRequest): Observable<GetDataSetConfigurationsResponse> {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(request)) {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, value.toString());
      }
    }

    return this.http.get<GetDataSetConfigurationsResponse>(`${this.api}`, { params });
  }

  create(request: CreateDataSetConfigurationRequest): Observable<any> {
    return this.http.post<GetDataSetConfigurationsResponse>(`${this.api}`, request);
  }

  getById(id: string): Observable<GetDataSetConfigurationResponse> {
    return this.http.get<GetDataSetConfigurationResponse>(`${this.api}/${id}`);
  }

  update(id: string, request: CreateDataSetConfigurationRequest): Observable<void> {
    return this.http.put<void>(`${this.api}/${id}`, request);
  }

  delete(id: string)
  {
    return this.http.delete<void>(`${this.api}/${id}`);
  }

  export(ids: string[]): Observable<ExportDataSetConfigurationResponse> {
    return this.http.post<ExportDataSetConfigurationResponse>(`${this.api}/export`, ids);
  }

  validateImport(file: File): Observable<ValidateImportDataSetConfigurationCommandResponse> {
    const formData = new FormData();
    formData.append('json', file);

    return this.http.post<ValidateImportDataSetConfigurationCommandResponse>(`${this.api}/validate-import`, formData);
  }

  importEntities(request: ImportRequest): Observable<string[]> {
    return this.http.post<string[]>(`${this.api}/import`, request);
  }

  bulkDelete(ids: string[]): Observable<void> {
    return this.http.delete<void>(`${this.api}/bulk-delete`, { body: ids });
  }
}
